import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ClaimEmptyState() {
  const { t } = useTranslation();
  return (
    <div className="bg-white border border-slate-200 rounded-xl py-16 flex flex-col items-center gap-3 text-slate-400">
      <ShieldAlert size={32} strokeWidth={1.25} className="opacity-40" />
      <p className="text-[13px]">{t('claims.empty')}</p>
    </div>
  );
}
